/**
 * Container Component
 * 
 * Global layout wrapper component providing consistent spacing and responsive widths.
 * Used throughout the application for content containment and centering.
 * 
 * Interactions:
 * - Uses styled-components for responsive layout rules
 * - Supports optional border prop for visual separation
 * - Provides consistent max-width and padding across all screen sizes
 * - Integrates with all page-level and section components for layout consistency
 * - Follows mobile-first responsive design patterns
 */

import { StyledContainer } from "./styles";
import { ContainerProps } from "../types";

const Container = ({ border, children }: ContainerProps) => (
  <StyledContainer border={border}>{children}</StyledContainer>
);

export default Container;
